<template>
  <div>
    <div class="row">
      <div class="col-4">
        <app-info :appInfo="systemInfo" v-on:refreshData="refreshData"></app-info>
      </div>
      <div class="col-3">
        <db-info :dbInfo="systemInfo" :no-env="true" v-on:refreshData="refreshData"></db-info>
      </div>
      <div class="col-3">
        <os-info :osInfo="systemInfo" :no-env="true" v-on:refreshData="refreshData"></os-info>
      </div>
      <div class="col-2">
        <ram-info :ramInfo="systemInfo" v-on:refreshData="refreshData"></ram-info>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <cpu-info :cpuInfo="systemInfo" v-on:refreshData="refreshData"></cpu-info>
      </div>
      <div class="col-3">
        <usage-info :usageInfo="systemInfo" v-on:refreshData="refreshData"></usage-info>
      </div>
      <div class="col-4">
        <license-info :licenseInfo="systemInfo.license" v-on:refreshData="refreshData"></license-info>
      </div>
    </div>
  </div>
</template>
<script>
import AppInfo from "../../components/Beast/SystemInfo/AppInfo.vue";
import DbInfo from "../../components/Beast/SystemInfo/DbInfo.vue";
import OsInfo from "../../components/Beast/SystemInfo/OsInfo.vue";
import CpuInfo from "../../components/Beast/SystemInfo/CpuInfo.vue";
import RamInfo from "../../components/Beast/SystemInfo/RamInfo.vue";
import UsageInfo from "../../components/Beast/SystemInfo/UsageInfo.vue";
import LicenseInfo from "../../components/Beast/SystemInfo/LicenseInfo.vue";

export default {
  components: {
    AppInfo, DbInfo, OsInfo, CpuInfo, RamInfo, UsageInfo, LicenseInfo
  },
  data() {
    return {
      systemInfo: {
        appName: "",
        version: "",
        environment: "",
        framework: "",
        frameworkVersion: "",

        dbHost: "",
        dbType: "",
        dbDatabase: "",

        arch: "",
        cpus: [
          {
            model: "",
            speed: 0
          }
        ],
        platform: "",
        release: "",
        type: "",
        hostname: "",

        uptime: 0,
        loadAverage: [
          0,
          0,
          0
        ],
        memoryUsage: {
          rss: 0,
          heapTotal: 0,
          heapUsed: 0,
          external: 0
        },

        freeMemory: 0,
        totalMemory: 0,
        usedMemory: 0,
        license: {
          limits: {
            users: 0,
            packages: {
              total: 0,
              without: 0,
              with: 0
            },
            organizations: 0,
            endDate: ""
          },
          usage: {
            users: 0,
            packages: {
              total: 0,
              without: 0,
              with: 0
            },
            organizations: 0
          },
          canCreate: {}
        }
      }
    };
  },
  methods: {
    async refreshData() {
      const response = await this.axios.get("/sysinfo");
      this.systemInfo = response.data;
    }
  },
  beforeMount() {
    this.refreshData();
  }
};
</script>
<style>

</style>
